/**
 * Module dependencies.
 */

import { ContainerWrapper } from './container.style';
import { JSX, ReactNode } from 'react';

/**
 * `Props` type.
 */

type Props = {
  children?: ReactNode;
  className?: string;
  relative?: boolean;
};

/**
 * Export `Container` component.
 */

export function Container({
  children,
  className,
  relative,
}: Props): JSX.Element {
  return (
    <ContainerWrapper className={className} relative={relative}>
      {children}
    </ContainerWrapper>
  );
}
